import { useState } from "react";

export default function ShareButton() {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const el = document.createElement("textarea");
        el.value = url;
        el.style.position = "fixed";
        el.style.opacity = "0";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2200);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleShare}
        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-background-100 border border-background-300 text-sm font-medium text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className={copied ? "ri-check-line text-primary-600" : "ri-link"}></i>
        {copied ? "链接已复制" : "复制链接分享"}
      </button>
    </div>
  );
}